import { useEffect } from 'react';
import withRouter from './withRouter';

const ScrollToTop = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return props.children;
};

export default withRouter(ScrollToTop);
